// Copied from mobile/src/shared/config/SelectOpts.ts
// Need to conslidate into a single location
export const optionsSex = [
  // {
  //   value: 0,
  //   label: "",
  // },
  {
    value: "1",
    label: "Male",
  },
  {
    value: "2",
    label: "Female",
  },
  {
    value: "3",
    label: "Indeterminate",
  },
  {
    value: "4",
    label: "Unknown",
  },
  {
    value: "5",
    label: "Intersex",
  },
  {
    value: "6",
    label: "Prefer not to answer",
  },
];

export const optionsGender = [
  // {
  //   value: 0,
  //   label: "",
  // },
  {
    value: "1",
    label: "Man or Male",
  },
  {
    value: "2",
    label: "Woman or Female",
  },
  {
    value: "3",
    label: "Non-Binary",
  },
  {
    value: "4",
    label: "Different term",
  },
  {
    value: "5",
    label: "Prefer not to answer",
  },
  {
    value: "9",
    label: "Not Stated",
  }
];

export const optionsPronouns = [
  {
    value: "1",
    label: "He/him",
  },
  {
    value: "2",
    label: "She/her",
  },
  {
    value: "3",
    label: "They/them",
  },
  {
    value: "4",
    label: "Another term",
  },
  {
    value: "5",
    label: "Not stated",
  },
  {
    value: "6",
    label: "Prefer not to answer",
  },
];

export const optionsRelationToPatient = [
  {
    value: "SPOUSE",
    label: "Spouse",
  },
  {
    value: "PARTNER",
    label: "Partner",
  },
  {
    value: "PARENT",
    label: "Parent",
  },
  {
    value: "CHILD",
    label: "Child",
  },
  {
    value: "SIBLING",
    label: "Sibling",
  },
  {
    value: "GRANDPARENT",
    label: "Grandparent",
  },
  {
    value: "GRANDCHILD",
    label: "Grandchild",
  },
  {
    value: "AUNT",
    label: "Aunt",
  },
  {
    value: "UNCLE",
    label: "Uncle",
  },
  {
    value: "NIECE",
    label: "Niece",
  },
  {
    value: "NEPHEW",
    label: "Nephew",
  },
  {
    value: "COUSIN",
    label: "Cousin",
  },
  {
    value: "CAREGIVER",
    label: "Caregiver",
  },
  {
    value: "GUARDIAN",
    label: "Guardian",
  },
  {
    value: "POWER_OF_ATTORNEY",
    label: "Power of Attorney",
  },
  {
    value: "MEDICAL_PROXY",
    label: "Medical Proxy",
  },
  {
    value: "FRIEND",
    label: "Friend",
  },
  {
    value: "NEIGHBOR",
    label: "Neighbor",
  },
  {
    value: "SOCIAL_WORKER",
    label: "Social Worker",
  },
  {
    value: "CASE_MANAGER",
    label: "Case Manager",
  },
  {
    value: "TRANSLATOR",
    label: "Translator",
  },
  {
    value: "INTERPRETER",
    label: "Interpreter",
  },
  {
    value: "ADVOCATE",
    label: "Advocate",
  },
  {
    value: "LEGAL_REPRESENTATIVE",
    label: "Legal Representative",
  },
  {
    value: "FOSTER_PARENT",
    label: "Foster Parent",
  },
  {
    value: "STEP_PARENT",
    label: "Step Parent",
  },
  {
    value: "STEP_CHILD",
    label: "Step Child",
  },
  {
    value: "IN_LAW",
    label: "In-Law",
  },
  {
    value: "SISTER_IN_LAW",
    label: "Sister-in-Law",
  },
  {
    value: "BROTHER_IN_LAW",
    label: "Brother-in-Law",
  },
  {
    value: "MOTHER_IN_LAW",
    label: "Mother-in-Law",
  },
  {
    value: "FATHER_IN_LAW",
    label: "Father-in-Law",
  },
  {
    value: "DAUGHTER_IN_LAW",
    label: "Daughter-in-Law",
  },
  {
    value: "SON_IN_LAW",
    label: "Son-in-Law",
  },
  {
    value: "OTHER_FAMILY",
    label: "Other Family Member",
  },
  {
    value: "OTHER_NON_FAMILY",
    label: "Other Non-Family",
  },
  {
    value: "UNKNOWN",
    label: "Unknown",
  },
];

export const optionsAllergySeverity = [
  {
    value: "anaphylaxis",
    label: "Anaphylaxis",
  },
  {
    value: "breathing",
    label: "Breathing Issues",
  },
  {
    value: "swelling",
    label: "Swelling",
  },
  {
    value: "vomiting",
    label: "Vomiting",
  },
  {
    value: "rash",
    label: "Rash",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const optionsWhen6MonthMarker = [
  {
    value: "lt1month",
    label: "Less than 1 month ago",
  },
  {
    value: "lt6months",
    label: "1 - 6 months ago",
  },
  {
    value: "gt6months",
    label: "More than 6 months ago",
  },
];